import { Platform } from 'react-native';
import DeviceInfo from 'react-native-device-info';

declare global {
  /**
   * Inlined by webpack DefinePlugin for the website bundle.
   * Absent under Metro and Jest unless a test sets it.
   * Must stay in sync with scripts/compiled-store-version.js.
   */
  var __APP_STORE_VERSION__: string | undefined;
}

/** Same default as scripts/compiled-store-version.js when the stamp is unset. */
const WEB_STORE_VERSION_WHEN_UNSET = '1.0.0';

function webStoreVersion(): string {
  const compiled = globalThis.__APP_STORE_VERSION__;
  if (typeof compiled !== 'string') {
    return WEB_STORE_VERSION_WHEN_UNSET;
  }
  const trimmed = compiled.trim();
  return trimmed.length > 0 ? trimmed : WEB_STORE_VERSION_WHEN_UNSET;
}

/**
 * Store version on the built application.
 * - Web: the string webpack compiled from VERSION_OVERRIDE
 * - iOS/Android: the binary via react-native-device-info
 */
export function getAppVersion(): string {
  if (Platform.OS === 'web') {
    return webStoreVersion();
  }
  return DeviceInfo.getVersion();
}

export function getBuildNumber(): string {
  if (Platform.OS === 'web') {
    return webStoreVersion();
  }
  return DeviceInfo.getBuildNumber();
}

export function getPlatformName(): string {
  switch (Platform.OS) {
    case 'ios':
      return 'iOS';
    case 'android':
      return 'Android';
    case 'web':
      return 'Web';
    default:
      return Platform.OS;
  }
}

export function getVersionDisplay(): string {
  const version = getAppVersion();
  const buildNumber = getBuildNumber();

  // Web has no separate build number, so the menu shows the store version once.
  if (Platform.OS === 'web' || version === buildNumber) {
    return `v${version}`;
  }

  return `v${version} (${buildNumber})`;
}
